import { SVGProps } from "react";

export default function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 459 463"
      {...props}
    >
      <path d="M213.435.562C91.8 9.81 0 116.17 0 238.716v113.297c0 9.248 6.884 18.496 16.067 23.122l52.783 16.187C68.85 430.63 98.683 463 137.7 463h22.95c13.771 0 22.95-9.248 22.95-23.122V254.904c0-13.874-9.179-23.122-22.95-23.122H137.7c-36.721 0-55.08 18.496-61.967 46.244L45.9 287.274v-48.557c0-99.424 73.442-184.974 172.125-191.91C323.595 39.87 413.1 125.418 413.1 231.78v55.492l-29.833-9.248v2.313c-6.884-30.057-25.246-48.557-61.967-48.557h-22.95c-13.771 0-22.95 9.248-22.95 23.122v184.974c0 13.874 9.179 23.122 22.95 23.122h20.654c39.017 0 68.85-32.37 68.85-69.365l55.079-16.187c9.18-2.313 16.067-11.561 16.067-23.122V231.779C459 97.672 346.545-8.688 213.435.561Z" />
    </svg>
  );
}
